import StaffStateTeg from './staff-state-tag';

export default StaffStateTeg;
